import { render, staticRenderFns } from "./medicalInsuranceSettleRecord.vue?vue&type=template&id=06cb4434"
import script from "./medicalInsuranceSettleRecord.vue?vue&type=script&lang=js"
export * from "./medicalInsuranceSettleRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports